<script>
	import { fade } from "svelte/transition";
	import { quadOut } from "svelte/easing";
	import { animationTime } from "./stores.js";

	import Pixel from "./Pixel.svelte";

	export let score = 0;

	$: calculateComment = () => {
		let comment = "An bhfuil teilifís agat? 🤔";
		if (score > 5) comment = "Níl caill ar bith ort! 😍";
		if (score > 8) comment = "Is tusa Intern TG4!🤩";
		return comment;
	};
	$: comment = calculateComment();

	let exit = false;
	const doExit = () => (exit = true);
	const exitUrl =
		"https://www.tg4.ie?utm_source=TheIndependent&utm_medium=Banner&utm_campaign=TheIndependent-QuizTG4ag25-DF21";
</script>

<div class="outro">
	<h2
		in:fade={{
			y: 200,
			duration: $animationTime,
			delay: $animationTime * 0,
			easing: quadOut,
		}}
	>
		You scored {score}/10
	</h2>
	<h1
		in:fade={{
			y: 200,
			duration: $animationTime,
			delay: $animationTime * 0.8,
			easing: quadOut,
		}}
	>
		{comment}
	</h1>
	<div>
		<a
			in:fade={{
				y: 200,
				duration: $animationTime,
				delay: $animationTime * 1.6,
				easing: quadOut,
			}}
			on:click={doExit}
			href={exitUrl}
			target="_blank">Visit the site</a
		>
	</div>
</div>
{#if exit}
	<Pixel selected="exit" active={true} />
{/if}

<style>
	.outro {
		height: calc((var(--height) * 0.7));
		display: grid;
		padding-top: 3rem;
	}
	a {
		position: relative;
		text-decoration: none;
		color: var(--white);
		background: var(--accent);
		padding: 0.5em 1em;
		margin: 2em auto;
		box-shadow: none !important;
	}
	a:hover {
		background: var(--accent-dark);
	}
</style>
